<template>
  <div class="confirm-wrapper" v-show="modules.length>0" >

    <mt-header fixed title="订单确认" style="background:#3189FF;color:#ffffff;">
        <mt-button icon="back" slot="left" @click="goBack"></mt-button>
    </mt-header>

    <div class="scroll-wrapper">
        <div class="scroll-content">
            <div class="goods_intro" v-if="modules.length>0">
                <img :src="goods.thumb" :alt="goods.title" class="good_pic">
                <div class="goods_detail">
                    <h3>{{goods.description}}</h3>
                    <span>{{selectModule.name}}</span>
                    <p>¥{{selectModule.price}}</p>
                </div>
            </div>
            <div class="order-info_wrapper">
                <p class="order-title">填写订单信息</p>
                <div class="form-wrapper">
                    <div class="content_form">
                        <div class="form_label" @click="show" >+{{code}}
                            <img src="../assets/images/down.png" class="code_arrow"/>
                        </div>
                        <input type="text" placeholder="请输入手机号码" class="phone" v-model="phone" @keyup="validInput" @focus="_focus" @blur="_blur"/>
                    </div>
                    <div class="phone_code" v-if="isShowVerify">
                        <input type="text" placeholder="请填写验证码" v-model="verify_code">
                        <div class="get_code">
                            <span v-if="!sms_show">{{count}}秒后重发</span>
                            <span v-if="sms_show" @click="getSms">获取验证码</span>
                        </div>
                    </div>
                    <div class="qq_wrapper">
                        <input type="text" placeholder="请填写QQ号码" class="qq_input" v-model="qq" @keyup="validInput"  @focus="_focus" @blur="_blur"/>
                    </div>
                    <div class="no_qq" @click="noQQAction">
                        如果您没有QQ，请点击这里
                    </div>
                    <div class="tips">
                        <span>重要：</span>请认真填写您的联系方式，工程师将通过此方式联系您并协助定位问题（请您下单后注意QQ验证消息和保持联系的手机畅通）
                    </div>
                </div>
            </div>
            <div class="prompt_wrapper">
                <p class="prompt_title">
                    <img src="../assets/images/global_warm_prompt_22x22_@3x.png" alt="温馨提示" class="warm_icon">温馨提示
                </p>
                <p class="prompt">
                    如果您的手机<span>无法接收到验证码</span> ，可以将您的联系方式发送到此邮箱 <a href="mailto:guoshixiongkefu@163.com">guoshixiongkefu@163.com</a> ，随后有专人对接您，帮助您完成下单并提供服务
                </p>
            </div>
        </div>
    </div>
    
    <div class="purchase-wrapper" v-if="modules.length>0" style="position: fixed;z-index:100000" >
        <div class="purchase-wrapper_fixed">
            <span class="fee">支付金额：<span class="money">¥{{selectModule.price}}</span></span>
            <button class="order_now" @click="createOrder" :class="{'valid':valid}">立即下单</button>
        </div>
    </div>
    <AwesomePicker  ref="pickers" :data="picker.slot" :textConfirm="picker.textConfirm"  :colorConfirm="picker.colorConfirm" :colorCancel="picker.colorCancel" @confirm="handlePickerConfirm"></AwesomePicker >
  </div>
</template>

<script>
import {Popup} from 'mint-ui';
import {Indicator } from 'mint-ui';
import picker from 'vue-3d-picker';

import AwesomePicker  from '../assets/lib/awesome-picker'

export default {
    name:"purchase",//购买服务
    metaInfo: {
        title: '果师兄官网_苹果手机数据恢复|微信聊天记录恢复|电脑数据恢复', // set a title
        meta: [{                 // set meta
          name: 'keyWords',
          content: '果师兄恢复大师,苹果数据恢复软件,手机数据恢复软件,电脑数据恢复'
        },{                 // set meta
          name: 'description',
          content: '果师兄恢复大师为用户提供电脑手机数据恢复服务,主要服务包括微信聊 天记录,短信,备忘录,微信好友添加,照片等苹果手机数据恢复,回收站清空文件恢复,U 盘/硬 盘/SD 卡/储存卡等各类存储设备数据恢复,以及相关的数据迁移、数据删除等指导服务'
        }]
    },
    data(){
        return{
            goods:{},
            modules:[],
            popupVisible:false,
            mid:"",//选中的id
            gid:"",
            module_values: [],
            selectModule:{},
            qq:"",
            phone:"",
            valid:false,
            styleObject:{
                position:'absolute'
            },
            country:"中国大陆",
            code:"86",
            code_options:"",
            country_options:"",
            picker:{
                slot:[],
                textConfirm:"完成",
                colorConfirm:"#3189FF",
                colorCancel:"#3189FF"
            },
            eng_no: '',
            isShowVerify: true,
            sms_show: true,
            verify_code: ''
        }
    },
    methods:{
        getSms(){
            var vm = this;
            this.count = 59;
            if(!vm.phone.replace(/\s+/g, "")){
                this.$toastlj("请输入手机号码")
                return
            }
            
            let info = {
               'phone':vm.phone
            }
            if(vm.code){
                info['country_code'] = vm.code
            }
            this.$store.dispatch("getVerifyCode",info).then((res)=>{
                var result = res.data;
                if(result.code == 0){
                     vm.countDown();
                     vm.sms_show = false;
                }
            })
        },
        countDown(){
            let vm = this;
            let interval = setInterval(function(){
                vm.count = vm.count -1;
                if(vm.count == 0){
                    vm.sms_show = true;
                    window.clearInterval(interval);  
                }
            },1000)
        },
        noQQAction(){
            this.qq = '000000'
        },
        _focus(){
            this.styleObject.position = "fixed"
        },
        _blur(){
            this.styleObject.position = "absolute";
            if(this.isWeiXin()){
                document.body.scrollTop = 0
            }
        
        },
        goBack(){
            history.go(-1);
        },
        show() {
            this.$refs.pickers.show();
        },
        handlePickerConfirm(item){
            this.country = this.country_arr[item[0].index].country;
            this.code = this.country_arr[item[0].index].code;
        },
        onValuesChange(picker, values) {
            let arr =  values.join().split(" ");
            this.code_options = arr[0].replace("+","");
            this.country_options = arr[arr.length-1];
        },
        getCountryCodes(){
            var vm = this;
            this.$store.dispatch("getCountryCodes").then((res)=>{
                var result = res.data;
                if(result.code == 0){
                    let countryCodes = result.res;
                    vm.country_arr = countryCodes;
                    let arr1 = [];
                    for(let i=0;i<countryCodes.length;i++){
                        let code = `<span class="country_code">+${countryCodes[i].code}</span><span class="country_name">${countryCodes[i].country}</span>`;
                        arr1.push(code)
                    }
                    vm.picker.slot.push(arr1)
                   
                }
            })
        },
        getQuestions(){
            var vm = this;
            this.$store.dispatch("getGoodsInfo",{gid:vm.gid,api_version:window.config.api_version}).then((res)=>{
                let data = res.data;
                if(data.code == 0){
                   vm.goods = data.res.data.goods;
                   vm.modules = data.res.data.groups;
                   vm.modules.forEach(function (item) {
                     for(let i=0;i<item.modules.length;i++){/*待修改*/
                       if(item.modules[i].id == vm.mid){
                         vm.selectModule = item.modules[i];
                       }
                     }
                   });
                }
            })
        },
        validInput(){
            var reg_qq=/^[0-9]{4,12}$/;
            if(this.code != 86){
                var reg_phone = /^\d{6,}$/;
            }else{
                var reg_phone = /^1\d{10}$/;
            }
            let qq = this.qq.replace(/\s+/g, "");
            if(reg_qq.test(this.qq) && reg_phone.test(this.phone)){
                this.valid = true;
            }else{
                this.valid = false;
            }
        },
        createOrder(){
            if(!this.valid){
                return
            }
            var vm = this;
            if(this.validToken()){
                
                if(this.code != 86){
                    var reg_phone = /^\d{6,}$/;
                }else{
                    var reg_phone = /^1\d{10}$/;
                }
                if(!vm.phone.replace(/\s+/g, "")){
                    this.$toastlj("请输入手机号码")
                    return
                }
                if(!reg_phone.test(vm.phone.replace(/\s+/g, ""))){
                    this.$toastlj("请输入正确的手机号码")
                    return
                }
                var reg=/^[0-9]{4,12}$/;
                let qq = this.qq;
                if(!reg.test(qq.replace(/\s+/g, ""))){
                    this.$toastlj("请输入正确的QQ号码")
                    return
                }
                if(!this.gid || !this.mid){
                    this.$router.replace({name:"home"});
                    return
                };
                
                let qa_batch_id;
                if(sessionStorage.batch_id){
                    if( sessionStorage.ghash ==  sessionStorage.ghash_home){
                        qa_batch_id = sessionStorage.batch_id;
                    }
                }
                let access_token =localStorage.access_token;
                if(!access_token){
                    vm.$router.push({name:"login"})
                }
                var data_ = {
                    info:{
                        gid:this.gid,
                        mid:this.mid,
                        qq:vm.qq.replace(/\s+/g, ""),
                        phone:vm.phone.replace(/\s+/g, ""),
                        cfrom:1,
                        qa_batch_id:qa_batch_id,
                        app_id:window.config.appid,
                        country_code:vm.code
                    },
                    access_token:access_token
                };
                if(this.module_values){
                    data_.info['goods_module_values'] = this.module_values
                }
                if(this.eng_no){
                    data_.info['eng_no'] = this.eng_no
                }
                if(this.verify_code){
                    data_.info['verify'] = this.verify_code
                }
                this.$store.dispatch("createOrder",data_).then((res)=>{
                    var data = res.data;
                    if(data.code ==0){
                        vm.$router.replace({name:"pay",query:{
                            orderno:data.res.order.orderno
                        }})
                    }else {
                        vm.$toastlj(data.message)
                    }
                })
            }

        },
        async getUserInfo(){
            let vm = this;
            if(this.validToken()){
                let access_token = localStorage.access_token;
                let info = {
                    'access_token':access_token
                };
                const res = await this.$store.dispatch("getUserinfo",info);
                Indicator.close();
                let data = res.data;
                if(data.code == 1200){
                    await new Promise(vm.refreshToken);
                    vm.getUserInfo();
                }else if (data.code == 1201){
                    vm.$router.push({name:"login"})
                }else if(data.code == 0){
                    vm.code = data.res.country_code;
                    if(vm.gid){
                        if(!vm.gid || !vm.mid){
                            vm.$router.replace({name:"home"});
                        }else{
                            vm.getQuestions();
                        }
                        vm.phone = data.res.user_bind_phone
                        if(vm.phone){
                            vm.isShowVerify = false
                        }else {
                            vm.isShowVerify = true
                        }
                    }
                }
            }
        }
    },
    created(){
        this.gid = this.$route.query.gid
        this.mid = this.$route.query.mid
        this.eng_no = this.$route.query.eng_no
        this.module_values = this.$route.query.modules
        if(!this.gid){
            this.gid = localStorage.primary_gid
            this.mid = localStorage.primary_mid
            this.eng_no = localStorage.primary_eng_no
            let module_values = localStorage.primary_modules
            if(module_values){
                this.module_values = module_values.split(',')
            }
        }
        
        
        if(this.validToken()){
            this.getUserInfo();
            this.getCountryCodes();
        };
    },
    mounted(){
      
    },
    components:{
        Popup,
        AwesomePicker
    },
    watch:{
      qq(){
        this.validInput();
      },
      phone(){
        this.validInput();
      }
    }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/ConfirmOrder.vue